import cf from './cf';
import i1zv8 from './i1zv8_20220517a';

export default class i1zv8a extends i1zv8 {

  constructor(props) {
    super(props);
    this.d_viewDefs = {
      name: '支払状況', // スタッフ用支払状況
      class: 'i1zv8a',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
